module.exports = __webpack_public_path__ + "static/media/banner_placeholder2.50c0a806.png";